import React from 'react';
import { get } from 'lodash';
import { useShowContextRequired } from 'ui-builder';
import { FileDto } from 'nekst-api';
import { FilePreview } from 'features/nekst-widgets';

interface DocumentFieldProps {
  source: string,
  // eslint-disable-next-line react/no-unused-prop-types
  label: string,
  fileDataSource: string
}

export default function DocumentField(
  props: DocumentFieldProps,
) {
  const showContext = useShowContextRequired();

  const value = get(showContext.data, props.source);

  const fileData = get(showContext.data, props.fileDataSource) as FileDto | undefined;

  if (value && fileData) {
    return (
      <FilePreview
        data={fileData}
      />
    );
  } else {
    return <span>-</span>;
  }
}
